<template functional>
  <div>
    <el-select
      v-model="$options.value"
      size="mini"
      placeholder="Tiempo"
      :disabled="true"
      @change="($event) => $options.OnminuteHourChange($event, data)"
    >
      <el-option
        v-for="item in $options.options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "MinuteHourSelector",
  props: {
    Value: {
      type: String,
      default: "h"
    }
  },
  value: "h",
  options: [
    {
      value: "m",
      label: "Minutos"
    },
    {
      value: "h",
      label: "Horas"
    }
  ],
  OnminuteHourChange(event, data) {
    if (event === "h" && data.attrs.row.TimeOntask > 8) {
      data.attrs.row.TimeOntask = 8;
    }
    data.attrs.row[data.attrs.column] = event;
    data.attrs.rowValue = event;
    data.attrs.updatingTypeOfTimeValue(data.attrs.row);
  }
};
</script>
